import { YLanguage } from '../lib/y/i18n';

export const $vars = {
    titlebar_color: '#ffbbea',
    facebook_app_id: '172416326664302',
    facebook_domains: ['abundolive.se'],
    oauth_redirect: 'https://abundolive.se/oauth_callback.html',
    default_language: 'sv' as YLanguage,
    supported_languages: ['en', 'sv', 'de'] as YLanguage[],
    recaptcha: {
        v3_key: '6Lf2CB0dAAAAANbhlYKfetzXkB0uGxnIVBRbV0h0'
    },
    google_api: {
        key: 'AIzaSyB2Fyct3cPmh4KwnJcNW1vK0gFNegMYGzc',
        client_id: '772105832124-nd3oqd1qrfj700ekki23gv8qqgjo6k52.apps.googleusercontent.com'
    },
    microsoft_api: {
        client_id: '7d2dfdb4-b3ac-4153-b7bd-1668d70c8d68',
    },
    stripe: {
        live_key: 'pk_live_51KxmphL3CMHnXVBHf5YK3skgG2adYAo8dcy5R0giws6nVDL6HyfmamFMXYa5q6w3czRaIbLlM7tw3LCVK5j013Hj009cx0ZzVN',
        test_key: 'pk_test_51KxmphL3CMHnXVBHc5UrDm1uDbuGfczPiyLUkp2sgYHRhhpk8y8skjbZRagG4RbacQ4elwqpv6wOQ3nEx30XvrG2005GEU6qCn'
    }
};
